// extracted by mini-css-extract-plugin
export default {"iq_card":"MyProfile_iq_card__uAeF7","iq_card_body":"MyProfile_iq_card_body__6BG7Q","avatar_div":"MyProfile_avatar_div__Noo8X","avatar_text":"MyProfile_avatar_text__Ppl09"};